import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { removeSession, getLoginSession, removeLoginSession, removeUserSessionId } from './utils';
import { removeUserData } from './store/userData/userDataSlice';
import { checkEmpty } from './helpers/utility';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const AuthProtectedRoute = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const checkSession = () => {
    const data = getLoginSession();
    if (checkEmpty(data)) {
      removeSession();
      dispatch(removeUserData());
      removeLoginSession();
      removeUserSessionId();
      navigate('/sign-in');
    }
  };

  useEffect(() => {
    checkSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <Outlet />;
};

export default AuthProtectedRoute;
